import { defineModule } from '@/js/utils/helpers';

export default defineModule(() => {});
